import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { fetchEvents, clearEventsErrors } from '../../actions';
import DialogModal from '../home/DialogModal';
import ActionButtons from '../home/ActionButtons';
import Alert from '../home/Alert';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  events: PropTypes.any,
  eventDelete: PropTypes.bool,
};

class ShowEvents extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      deleteId: 0,
      alertOpen: false,
      alertMessage: '',
      delete: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.eventDelete && (this.state.delete || nextProps.events.delete)) {
      const events = nextProps.events;
      events.delete = false;
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: '',
        events,
      });
      this.handleClose();
    }
    if (nextProps.error) {
      this.setState({
        delete: false,
        alertOpen: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
  }
  handleOpen(id) {
    this.setState({
      open: true,
      deleteId: id,
    });
  }
  handleClose() {
    this.setState({
      open: false,
      deleteId: 0,
    });
  }

  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    this.props.dispatch(clearEventsErrors());
    this.props.dispatch(fetchEvents({ page: 1 }));
  }
  renderRowsTable() {
    return this.props.events.results.map(e =>
      <TableRow key={e.id}>
        <TableRowColumn style={{ width: '20%' }} key={e.id}>{e.eventId}</TableRowColumn>
        <TableRowColumn style={{ width: '15%' }} key={e.id}>{e.type}</TableRowColumn>
        <TableRowColumn style={{ width: '15%' }} key={e.id}>{e.subType}</TableRowColumn>
        <TableRowColumn style={{ width: '15%' }} key={e.id}>{new Date(e.date).toLocaleString()}</TableRowColumn>
        <TableRowColumn key={e.id} style={{ width: '20%' }}>
          <ActionButtons
            onView={`/events/view/${e.id}`}
            // onDelete={() => this.handleOpen(item.id)}
            // onDisable={() => this.handleDisable(item)}
            // disabled={item.disabled}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.handleDelete()}
          dialogTitle="Delete Event"
          dialogMessage="Do you really want to delete this event?"
          dialogActionTitle="Delete"
        />
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <Table>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn style={{ width: '20%' }}>Event Id</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '15%' }}>Type</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '15%' }}>Event Action</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '15%' }}>Event Date</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '20%', textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowEvents.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowEvents.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    eventDelete: state.events.eventDelete,
    error: state.events.error,
    events: state.events,
  };
}

export default connect(mapStateToProps)(ShowEvents);



// WEBPACK FOOTER //
// ./src/components/events/ShowEvents.js